var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",style:({'background-image':'url('+_vm.banner.img+')'})},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.banner.title)}}),(_vm.banner.p)?_c('p',[_vm._v(_vm._s(_vm.banner.p))]):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.banner.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }